export default "__VITE_ASSET__CoFSLKib__"